// extracted by mini-css-extract-plugin
export default {"pin":"SetNewPasswordStep_pin__vuIie"};